<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { inject } from 'vue'
import { cn } from '@ds/lib/utils'
import { Input } from '@ds/primitives/input'
import { INPUT_GROUP_SIZE } from '.'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const groupSize = inject(INPUT_GROUP_SIZE)
</script>

<template>
  <Input
    data-slot="input-group-control"
    :size="groupSize"
    :class="cn(
      'flex-1 min-w-0 rounded-none border-0 bg-transparent focus-visible:shadow-none',
      props.class,
    )"
  />
</template>
